import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/HomePage.vue'),
    meta: { title: '首页', description: '项目与学习入口', navigation: true, stage: 3 },
  },
  {
    path: '/knowledge',
    name: 'knowledge',
    component: () => import('@/pages/KnowledgePage.vue'),
    meta: {
      title: '知识库',
      description: '分类、搜索、筛选与知识详情',
      navigation: true,
      stage: 4,
    },
  },
  {
    path: '/knowledge/:id',
    name: 'knowledge-detail',
    component: () => import('@/pages/KnowledgeDetailPage.vue'),
    meta: {
      title: '知识详情',
      description: '知识正文、来源与个人记录',
      navigation: false,
      stage: 4,
    },
  },
  {
    path: '/distinctions',
    name: 'distinctions',
    component: () => import('@/pages/DistinctionPage.vue'),
    meta: {
      title: '易错辨析',
      description: '源内容易混表达、上下文与个人错题关联',
      navigation: true,
      stage: 2,
    },
  },
  {
    path: '/timeline',
    name: 'timeline',
    component: () => import('@/pages/TimelinePage.vue'),
    meta: {
      title: '常识时间线',
      description: '可靠事件日期、时间顺序与知识点入口',
      navigation: true,
      stage: 3,
    },
  },
  {
    path: '/study',
    name: 'study',
    component: () => import('@/pages/StudyPage.vue'),
    meta: { title: '学习', description: '每日知识卡片与掌握度记录', navigation: true, stage: 5 },
  },
  {
    path: '/review',
    name: 'review',
    component: () => import('@/pages/ReviewPage.vue'),
    meta: { title: '复习', description: '到期知识与复习计划', navigation: true, stage: 5 },
  },
  {
    path: '/quiz',
    name: 'quiz',
    component: () => import('@/pages/PracticePage.vue'),
    meta: {
      title: '练习',
      description: '分类练习、随机练习与答题解析',
      navigation: true,
      stage: 6,
    },
  },
  {
    path: '/wrong-questions',
    name: 'wrong-questions',
    component: () => import('@/pages/WrongQuestionsPage.vue'),
    meta: { title: '错题本', description: '错误记录与重新练习', navigation: true, stage: 6 },
  },
  {
    path: '/practice-history',
    name: 'practice-history',
    component: () => import('@/pages/PracticeHistoryPage.vue'),
    meta: {
      title: '刷题记录',
      description: '按日期与试卷回顾 Markdown 派生的常识刷题积累',
      navigation: true,
      stage: 5,
    },
  },
  {
    path: '/practice-history/:sessionId',
    name: 'practice-history-detail',
    redirect: (to) => ({
      name: 'practice-history',
      query: { session: String(to.params.sessionId ?? '') },
    }),
    meta: {
      title: '刷题记录',
      description: '兼容旧详情链接并在列表页展开对应记录',
      navigation: false,
      stage: 5,
    },
  },
  {
    path: '/practice-attempt-history',
    name: 'practice-attempt-history',
    component: () => import('@/pages/PracticeAttemptHistoryPage.vue'),
    meta: {
      title: '练习历史',
      description: '按 Session 查看站内真实作答结果与重练入口',
      navigation: true,
      stage: 5,
    },
  },
  {
    path: '/practice-attempt-history/:sessionId',
    name: 'practice-attempt-history-detail',
    component: () => import('@/pages/PracticeAttemptHistoryDetailPage.vue'),
    meta: {
      title: '练习历史详情',
      description: '查看本次站内练习汇总与逐题 Attempt',
      navigation: false,
      stage: 5,
    },
  },
  {
    path: '/favorites',
    name: 'favorites',
    component: () => import('@/pages/KnowledgePage.vue'),
    props: { favoriteOnly: true },
    meta: { title: '收藏', description: '已收藏的知识点', navigation: true, stage: 4 },
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: () => import('@/pages/StatisticsPage.vue'),
    meta: { title: '统计', description: '学习进度与趋势', navigation: true, stage: 7 },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/pages/SettingsPage.vue'),
    meta: { title: '设置', description: '学习计划、主题与本地数据', navigation: true, stage: 7 },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/pages/NotFoundPage.vue'),
    meta: { title: '页面不存在', navigation: false },
  },
]

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.afterEach((route) => {
  if (typeof document !== 'undefined') document.title = `${route.meta.title} · 常识研习`
})
